<template>
  <section role="menu">
    <div class="modal fade" id="modalSesc" tabindex="-1" role="dialog" aria-labelledby="modalSescLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="modalSescLabel">
              Credenciamento Prefeitura de Santos - SESC
            </h4>
          </div>
          <div class="modal-body">
            <div class="row row-field" style="padding-bottom: 15px">
              <div class="col-md-12 col-sm-12">
                <p style="text-align: justify">
                  Olá!<br /><br />

                  Esta ação de Credenciamento do Sesc é exclusiva para os servidores ativos da Prefeitura
                  Municipal de Santos e ficará disponível para preenchimento a partir das 10h30 do 1º dia útil do
                  mês (exceto segundas-feiras), por 48 horas, ou até atingir o limite permitido no contrato, a saber,
                  300 inscrições/mês.
                  <br /><br />
                  <strong>Para acessar o link do formulário, faz-se necessário “atualizar os dados de navegação”,
                  </strong>
                  limpando o histórico de seu navegador, preferindo computadores ou notebook.
                  <br /><br />
                  Após o período de preenchimento, os dados serão validados pela Prefeitura Municipal de Santos,
                  a qual procederá com <strong>desconto único anual</strong> na folha de pagamento no valor
                  de R$40,00 (quarenta reais), referente ao credenciamento do titular.
                  <br /><br />
                  Para ativar sua credencial MIS digital, você receberá um SMS recomendando a instalação do
                  aplicativo “Credencial Sesc SP” (iOS ou Android). Desta forma é OBRIGATÓRIO informar seu
                  número de celular e aceitar o recebimento de SMS durante o preenchimento deste formulário.
                  Lembramos que a credencial MIS tem validade de 1 (um) ano, com abrangência no estado de
                  São Paulo e não cria vínculo com o Sesc, assim como não concede os mesmos benefícios
                  oferecidos aos trabalhadores do Comércio de Bens, Serviços e Turismo.
                  <br /><br />
                  Para iniciarmos o processo de credenciamento MIS, tenha em mãos seus documentos pessoais
                  (RG, CPF e uma foto).
                <p>
                  <br />Importante! <br /><br />
                  O não preenchimento dos dados, assim como o preenchimento incompleto, serão considerados
                  como inconsistência cadastral.
                </p>
                <br />
                <p>
                  Caso o limite de 300 (trezentas) inscrições/mês seja alcançado no prazo de 48 horas, o servidor
                  deverá aguardar o próximo período para inscrever-se novamente, por não haver lista de espera.
                </p>
                <br />
                <p>
                  <strong>
                    Link do formulário eletrônico de inscrição para credenciamento dos servidores da
                    Prefeitura Municipal de Santos:
                  </strong>
                <p>
                  <strong>Acesso:</strong><br />
                  <a href="https://form.jotform.com/241063912551652">https://form.jotform.com/241063912551652</a>
                </p>
                </p>
                <p>
                  <br />
                <p>
                  <strong>Manual para cadastramento no sistema do SESC, contendo perguntas e respostas
                    frequentes:
                  </strong>
                </p>
                <br />
                <a style="cursor: pointer" @click="baixaArquivo('Manual_MIS_7.0.pdf')">Acessar Manual</a>
                </p>
                <p><br />
                  <strong>
                    Lista contendo Nome e Registro dos servidores contemplados no último mês (os quais
                    deverão AGUARDAR desconto na folha de pagamento, bem como contato do SESC através
                    de SMS para efetivação do credenciamento no App Credencial Sesc SP, podendo baixar
                    desde já):
                  </strong>
                </p>
                <br />
                <a style="cursor: pointer" @click="baixaArquivo('descontados-mes.pdf')">Acessar lista</a>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <botao estilo="cheio-verde" rotulo="OK" icone="ok-modal" dismiss="modal"></botao>
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar navbar-default">
      <div class="container" style="padding-left: 0px">
        <div class="container-fluid">
          <ul class="nav navbar-nav">
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" :class="declaracaoAtiva" data-toggle="dropdown" role="button"
                aria-haspopup="true" aria-expanded="false">Declarações</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link :to="{ name: 'DeclaracaoBens' }">Declaração de Bens</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'Dependente' }">Parceiro Econômico</router-link>
                </li>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" :class="avaliacaoAtiva" data-toggle="dropdown" role="button"
                aria-haspopup="true" aria-expanded="false">Avaliações</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link :to="{ name: 'Avaliacao' }">Avaliação Periódica</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'AvaliacaoEstagioProbatorio' }">Estágio Probatório</router-link>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" class="dropdown-toggle" :class="recadastramentoAtiva" data-toggle="dropdown" role="button"
                aria-haspopup="true" aria-expanded="false">Atualização Cadastral</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link :to="{ name: 'MesCompetenciaOrdenado' }">Dados Pessoais</router-link>
                </li>
                <!--
                <li>
                  <router-link :to="{ name: 'DadosPessoais' }">Dados Pessoais</router-link>
                </li>
                
                <li>
                  <router-link :to="{ name: 'DependenteCpf' }">CPF's de Familiares</router-link>
                </li>
                -->
              </ul>

            </li>
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" :class="feriasAtiva" data-toggle="dropdown" role="button"
                aria-haspopup="true" aria-expanded="false">Férias</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link :to="{ name: 'Ferias' }">Agendamento de Férias
                  </router-link>
                </li>
                <li v-if="ehResponsavelAprovador">
                  <router-link :to="{ name: 'Aprovacao' }">
                    Aprovação de Férias
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="valeAlimentacaoHabilitado" class="dropdown">
              <a href="#" class="dropdown-toggle" :class="valeAlimentacaoAtiva" data-toggle="dropdown" role="button"
                aria-haspopup="true" aria-expanded="false">Vale-Alimentação</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link :to="{ name: 'ValeAlimentacao' }">Escolha do Vale-Alimentação
                  </router-link>
                </li>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" :class="formulariosAtiva" data-toggle="dropdown" role="button"
                aria-haspopup="true" aria-expanded="false">Formulários</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link :to="{ name: 'FaltaLei' }">Falta Lei</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'DeclaracaoInclusaoImpostoRenda' }">Declaração de Inclusão IR</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'DeclaracaoExclusaoImpostoRenda' }">Declaração de Exclusao IR</router-link>
                </li>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                aria-expanded="false">Links</a>
              <ul class="dropdown-menu">
                <li>
                  <a href="https://egov.santos.sp.gov.br/jornada" target="_blank" rel="noopener">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    &nbsp;Jornada
                  </a>
                </li>
                <li>
                  <a href="https://egov.santos.sp.gov.br/jornada/downloads/manual.pdf" target="_blank" rel="noopener">
                    <i class="fa fa-book" aria-hidden="true"></i>
                    &nbsp;Manual
                  </a>
                </li>
                <li>
                  <a href="https://egov.santos.sp.gov.br/jornada/downloads/formularios.docx" target="_blank"
                    rel="noopener">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                    &nbsp;Anexo Único
                  </a>
                </li>
                <li>
                  <a href="https://entrega.santos.sp.gov.br" target="_blank" rel="noopener">
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                    &nbsp;Entrega
                  </a>
                </li>
                <hr />
                <li>
                  <a href="https://webmail.santos.sp.gov.br" target="_blank" rel="noopener">
                    <i class="fa fa-envelope-o" aria-hidden="true"></i>
                    &nbsp;WebMail
                  </a>
                </li>
                <li>
                  <a href="https://egov.santos.sp.gov.br/sigm_web_adm_sistema" target="_blank" rel="noopener">
                    <i class="fa fa-stethoscope" aria-hidden="true"></i>
                    &nbsp;Perícia Médica
                  </a>
                </li>
                <hr />
                <li>
                  <a href="https://egov.santos.sp.gov.br/contador" target="_blank" rel="noopener">
                    <i class="fa fa-usd" aria-hidden="true"></i>
                    &nbsp;Holerite
                  </a>
                </li>
                <li>
                  <a href="https://egov.santos.sp.gov.br/contador" target="_blank" rel="noopener">
                    <i class="fa fa-paw" aria-hidden="true"></i>
                    &nbsp;Informe de Rendimentos
                  </a>
                </li>
                <li>
                  <a href="https://egov.santos.sp.gov.br/contador" target="_blank" rel="noopener">
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    &nbsp;Contagem de Tempo
                  </a>
                </li>
                <hr />
                <li>
                  <a href="https://egov.santos.sp.gov.br/legis/documents/55" target="_blank" rel="noopener">
                    <i class="fa fa-balance-scale" aria-hidden="true"></i>
                    &nbsp;Estatuto
                  </a>
                </li>
                <li>
                  <a href="https://www.santos.sp.gov.br/portal/servidor" target="_blank" rel="noopener">
                    <i class="fa fa-globe" aria-hidden="true"></i>
                    &nbsp;Portal do Servidor
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
import Botao from '@/components/botao';
import FileHelper from '@/helpers/FileHelper';
import ValeAlimentacaoService from '@/services/valeAlimentacaoService';

export default {
  name: 'barra-menu',

  data() {
    return {
      funcionario: this.$store.state.funcionario,
      perfis: this.$store.state.usuarioLogado.perfis,
      valeAlimentacaoHabilitado: false,
    };
  },
  methods: {
    async verificaValeAlimentacao() {
      if (!this.$store.state.token) {
        this.valeAlimentacaoHabilitado = false;
        return;
      }
      try {
        this.valeAlimentacaoHabilitado = Boolean(
          await ValeAlimentacaoService.verificarHabilitacao()
        );
      } catch (error) {
        this.valeAlimentacaoHabilitado = false;
      }
    },
    modalSesc() {
      jQuery('#modalSesc').modal('show');
    },
    baixaArquivo(arquivo) {
      FileHelper.download(arquivo, this);
    },
  },
  components: {
    Botao,
  },
  props: {
    rotas: {
      type: Array,
      required: true,
    },
    declaracaoVisitada: {
      type: Boolean,
      required: false,
    },
    avaliacaoVisitada: {
      type: Boolean,
      required: false,
    },
    recadastramentoVisitada: {
      type: Boolean,
      required: false,
    },
    formulariosVisitada: {
      type: Boolean,
      required: false,
    },
    feriasVisitada: {
      type: Boolean,
      required: false,
    },
    valeAlimentacaoVisitada: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ehResponsavelAprovador() {
      if (this.perfis) {
        return this.perfis.includes('APROVADOR_AGENDAMENTO_FERIAS');
      }
      return false;
    },
    declaracaoAtiva() {
      if (this.declaracaoVisitada) return 'active';
    },
    avaliacaoAtiva() {
      if (this.avaliacaoVisitada) return 'active';
    },
    recadastramentoAtiva() {
      if (this.recadastramentoVisitada) return 'active';
    },
    formulariosAtiva() {
      if (this.formulariosVisitada) return 'active';
    },
    feriasAtiva() {
      if (this.feriasVisitada) return 'active';
    },
    valeAlimentacaoAtiva() {
      if (this.valeAlimentacaoVisitada) return 'active';
    },
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
    permissoes() {
      return this.$store.state.usuarioLogado.perfis;
    },
    tokenAtual() {
      return this.$store.state.token;
    },
  },
  watch: {
    usuarioAtual(novo, anterior) {
      this.funcionario = novo;
      this.verificaValeAlimentacao();
    },
    permissoes(novo, anterior) {
      this.perfis = novo;
      this.verificaValeAlimentacao();
    },
    tokenAtual() {
      this.verificaValeAlimentacao();
    },
  },
  created() {
    this.verificaValeAlimentacao();
  },
};
</script>

<style scoped>
.navbar {
  margin-bottom: 0px;
  min-height: 53px;
  position: relative;
}

.navbar-default {
  background: #00615c none repeat scroll 0 0;
  border-color: #00615c;
  border-bottom: 1px solid #004f4a;
  color: #ffffff;
  border-radius: 0;
  margin-bottom: 20px;
  width: 100%;
  height: 53px;
  position: fixed;
  left: 0;
  top: 53px;
  z-index: 900;
}

.page-header-bg {
  overflow: hidden;
  position: relative;
  background: #00615c;
  margin-bottom: 20px;
  width: 100%;
  height: 53px;
}

.header-bg-cadastro {
  position: fixed;
  left: 0;
  top: 53px;
  border-bottom: 1px solid #004f4a;
}

ul {
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 2.4rem;
  margin: 0 0 2.2rem;
}

.nav>li {
  display: block;
  margin-top: 8px;
  position: relative;
}

.navbar-nav>li>a {
  border-radius: 0;
  color: #a1be4d;
  display: block;
  font-size: 0.85em;
  font-weight: bold;
  padding: 10px 15px;
  position: relative;
  text-transform: uppercase;
}

.navbar-nav>li>a.active,
.navbar-nav>li>a:focus,
.navbar-nav>li>a:hover,
.navbar-nav>li>a:visited {
  background-color: rgba(0, 0, 0, 0);
  border-bottom: 3px solid;
  text-decoration: none;
  border-radius: 0;
  color: #a1be4d;
  display: block;
  font-size: 0.85em;
  font-weight: bold;
  padding: 10px 15px;
  position: relative;
  text-transform: uppercase;
}

.dropdown-menu {
  font-size: 0.9em;
}

.navbar-default .navbar-nav>.open>a,
.navbar-default .navbar-nav>.open>a:hover,
.navbar-default .navbar-nav>.open>a:focus,
.navbar-default .navbar-nav>.open>a:active {
  background-color: rgba(0, 0, 0, 0);
  color: #a1be4d;
}

.dropdown-menu>li>a {
  color: #468b35;
}

.dropdown-menu>li>a:hover,
.dropdown-menu>li>a:focus {
  text-decoration: none;
  color: #a1be4d;
  background-color: #eefceb;
}

hr {
  margin: 5px 10px;
  border-color: #deecda;
}

@media screen and (min-width: 768px) {
  .navbar-default {
    background: #00615c none repeat scroll 0 0;
    border-color: #00615c;
    border-bottom: 1px solid #004f4a;
    color: #ffffff;
    border-radius: 0;
    margin-bottom: 20px;
    width: 100%;
    height: 53px;
    position: fixed;
    left: 0;
    top: 53px;
  }

  .page-header-bg {
    overflow: hidden;
    position: relative;
    background: #00615c;
    margin-bottom: 20px;
    width: 100%;
    height: 53px;
  }

  .header-bg-cadastro {
    position: fixed;
    left: 0;
    top: 53px;
    border-bottom: 1px solid #004f4a;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?1a1fb828